import React from 'react';
import { t, Trans } from '@lingui/macro';

import { Link } from '@rover/kibble/core';

export const ACTIVATE_ACCOUNT_TITLE_TEXT = (): string => t`Activate your account`;
export const ACTIVATE_ACCOUNT_HEADER_TEXT = (): string => t`ACTIVATE YOUR ACCOUNT`;
export const ONBOARDING_HEADER_TEXT = (isSitter: boolean): string => {
  if (isSitter) {
    return t`A few last steps...`;
  }
  return t`You’re all set!`;
};

export const ONBOARDING_TEXT = (isSitter: boolean): string[] => {
  if (isSitter) {
    return [
      t`Your new sitter account now has all your existing bookings, clients, and settings. You can complete any previously booked stays and message all of your clients.`,
      t`All future bookings will be managed from your sitter account on Rover. Continue to Rover to complete a few additional steps so your services continue smoothly. While you’re there, take a moment to explore your new tools and settings.`,
    ];
  }
  return [t`Ready to explore? Take a look around to see what's new!`];
};

export const ACTIVATE_ACCOUNT_TEXT = (): string =>
  t`Cat in a Flat is now part of the Rover Group. Activate your account to access powerful new search features, improved booking management, and a wider range of pet care options both in your neighborhood and around the world.`;
export const TOS_TEXT = (tosUrl?: string, privacyPolicyUrl?: string): JSX.Element => (
  <Trans>
    By checking this box, I agree to Rover{' '}
    <Link asInlineLink href={tosUrl ?? '/terms/tos/'} target="_blank">
      {' '}
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link asInlineLink href={privacyPolicyUrl ?? '/terms/privacy/'} target="_blank">
      {' '}
      Privacy Statement
    </Link>{' '}
    and confirm that I am 18 years of age or older.
  </Trans>
);

export const MARKETING_EMAILS_TEXT = (): JSX.Element => (
  <Trans>
    Yes, I want to receive marketing emails and messages from Rover and its affiliates. I can
    unsubscribe at any time.
  </Trans>
);

export const ACTIVATION_BUTTON_TEXT = (): string => t`Accept and activate my account`;
export const SEARCH_BUTTON_TEXT = (): string => t`Search for pet care`;
export const PROFILE_BUTTON_TEXT = (): string => t`Complete my profile on Rover`;
export const VIEW_BOOKINGS_BUTTON_TEXT = (isUserProvider: boolean): string =>
  isUserProvider ? t`View my bookings on Rover` : t`View my bookings`;
export const FAQS_SECTION_SUBHEADER_TEXT = (
  helpCenterUrl: string,
  onHelpCenterClick?: () => void
): JSX.Element => (
  <Trans>
    Visit the{' '}
    <Link asInlineLink href={helpCenterUrl} target="_blank" onPress={onHelpCenterClick}>
      Help Center
    </Link>{' '}
    if you have additional questions.
  </Trans>
);

export const CONSENT_ERROR_TEXT = (): string => t`Something went wrong. Please try again.`;

export const ROVERLAPPER_MERGE_HEADER_TEXT = (brandName: string): string =>
  t`Merge your ${brandName} Account with your Rover Account`;
export const ROVERLAPPER_MERGE_BODY_TEXT = (brandName: string): string =>
  t`Merge your ${brandName} account to bring your bookings, messages and reviews to Rover. Questions? Look at the FAQ section below.`;
export const ROVERLAPPER_MERGE_BUTTON_TEXT = (): string => t`Move my data`;
export const ROVERLAPPER_MERGE_ERROR_TEXT = (): string =>
  t`Something went wrong. Please try again.`;
export const ROVERLAPPER_MERGE_SUCCESS_TEXT = (): string =>
  t`It may take a few minutes for all of your information to appear. If it has been an hour and you still don't see everything, please contact support.`;
